var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM7.48462 5.41667H18.5157C19.0595 5.41667 19.5003 5.85511 19.5 6.39535V20.688C19.5 21.2285 19.0592 21.6667 18.5154 21.6667H7.48462C6.94111 21.6667 6.5 21.2285 6.5 20.688V6.39535C6.5 5.85479 6.94111 5.41667 7.48462 5.41667ZM12.245 19.905C12.245 20.3197 12.583 20.6557 13.0002 20.6557C13.417 20.6557 13.7554 20.3194 13.7554 19.905C13.7554 19.4904 13.417 19.1544 13.0002 19.1544C12.583 19.1544 12.245 19.4904 12.245 19.905ZM17.1041 18.2083C17.6479 18.2083 18.0887 17.7702 18.0887 17.2297V8.0927C18.0887 7.55215 17.6479 7.11402 17.1041 7.11402H8.89658C8.35274 7.11402 7.91195 7.55215 7.91195 8.0927V17.2297C7.91195 17.7702 8.35274 18.2083 8.89658 18.2083H17.1041ZM9.20833 8.66667H12.4583V11.9167H9.20833V8.66667ZM12.4583 13H9.20833V16.25H12.4583V13ZM13.5417 8.66667H16.7917V11.9167H13.5417V8.66667ZM16.7917 13H13.5417V16.25H16.7917V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartApp);
export default __webpack_public_path__ + "static/media/restart_app.bd3e26cd7c9ffc7e7e5b68f5cf5ad3c8.svg";
export { ForwardRef as ReactComponent };